<template>
    <v-layout>
        <router-view/>

        <div class="toast-container">
            <div class="toast-holder">
                <div v-for="toast of state.toasts" :key="toast.id" class="mt-2">
                    <v-alert :type="toast.type" closable border="start">{{ toast.message }}</v-alert>
                </div>
            </div>
        </div>
    </v-layout>
</template>

<script lang="ts" setup>
import {reactive, onMounted} from 'vue';
import {remove} from "lodash";
import {useBus} from "@/pcm/plugins/helper";

const state = reactive({
    toasts: [] as Array<any>,
    toastId: 0 as number,
});

const addToast = (toast: any) => {
    const id = ++state.toastId;

    state.toasts.push({
        ...toast,
        ...{
            id: id,
        }
    } as never);

    setTimeout(() => {
        remove(state.toasts, ['id', id]);
    }, toast.time * 1000);
}

onMounted(() => {
    useBus().on('toast', addToast);
});
</script>
